import { PatientInfo } from 'views/components';
import { Row } from 'reactstrap';
import moment from 'moment';
import { patientActions } from 'core/Patient';
import { useTranslation } from 'react-i18next';
import {
    ButtonFooter,
    Card,
    ExpandButton,
    FormGroup,
    Loader,
    Text
} from 'mol-ui';
import {
    Container,
    StyledCol
} from './styled';
import React, { useEffect } from 'react';
import {
    useDispatch,
    useSelector
} from 'hooks';
import {
    useHistory,
    useParams
} from 'react-router-dom';

const AbsenceReportView = () => {

    const dispatch = useDispatch();
    const { id: idParam } = useParams();
    const { t } = useTranslation();
    const { push } = useHistory();
    const id = Number(idParam);

    const {
        absenceReport,
        absenceReportLoading
    } = useSelector('patient');
    const {
        absence_reason,
        absence_report_reason,
        alternative_address,
        comment,
        date,
        diagnostic_classification,
        doctor,
        familiar_identification,
        parsedFamiliarRelation,
        parsedStatus,
        patient: {
            id: patient_id
        } = {},
        processed_range,
        range,
        return_to_work_at,
        status_comment,
        workplace
    } = absenceReport;

    const {
        first_name,
        last_name
    } = doctor ?? {};
    const doctor_name = doctor ? `${ last_name }, ${ first_name }` : '';

    useEffect(() => {
        dispatch(patientActions.getAbsenceReport(id));
    }, [id]);

    if (absenceReportLoading) return <Loader active />;

    const data = [{
        label: t('Profesional'),
        value: doctor_name
    }, {
        label: t('Estado'),
        value: parsedStatus
    }, {
        label: t('Fecha'),
        value: date
    }, {
        label: t('Fecha solicitada'),
        value: range
    }, {
        label: t('Rango procesado'),
        value: processed_range
    }, {
        label: t('Familiar'),
        value: parsedFamiliarRelation
    }, {
        label: t('Datos del familiar'),
        md: 8,
        value: familiar_identification
    }, {
        label: t('Razón'),
        md: 12,
        value: absence_reason
    }, {
        label: t('Razón'),
        value: absence_report_reason?.name
    }, {
        label: t('Dirección'),
        value: alternative_address
    }, {
        label: t('Lugar de trabajo'),
        value: workplace
    }, {
        label: t('Clasificación'),
        value: diagnostic_classification?.name
    }, {
        label: t('Comentarios'),
        md: 12,
        value: comment
    }, {
        label: t('Comentarios del profesional'),
        md: 12,
        value: status_comment
    }, {
        label: t('Aviso de reincorporación'),
        value: return_to_work_at ? moment(return_to_work_at).format('DD/MM/YYYY HH:mm') : ''
    }];

    return (
        <Container>
            <Card title={ t('Información del paciente') }>
                <PatientInfo id={ patient_id } />
            </Card>
            <Card title={ t('Informe de ausencia') }>
                <Row>
                    {
                        data.map(({ label, md = '4', value }, index) => {
                            if (value === null || value === undefined || value === '') return null;
                            return (
                                <StyledCol key={ index } md={ md } xs="12">
                                    <FormGroup label={ label } margin="0px 0px 10px 0px" size="12px">
                                        <Text margin="5px 0px 0px 0px">{ value }</Text>
                                    </FormGroup>
                                </StyledCol>
                            );
                        })
                    }
                </Row>
            </Card>
            <Card>
                <ButtonFooter>
                    <ExpandButton
                        caption={ t('Volver') }
                        size={ 100 }
                        width={ 120 }
                        onClick={ () => push(t('/ausencias')) }
                    />
                </ButtonFooter>
            </Card>
        </Container>
    );
};

export default AbsenceReportView;
